module.exports = __webpack_public_path__ + "static/media/2025-05-01-01.da6dc294.jpg";